import { inEnum, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { DeviceSubscription, SubscriptionIdentifier, SubscriptionListResponse } from "../api/types/SubscriptionTypes.js";

export enum SubscriptionStatus {
    DENIED = "denied",
    BLOCKED = "blocked",
    NEVER_ASKED = "never",
    ENABLED = "enabled"
}

export interface SystemSubscriptionWrapper {
    subscriptionStatus: SubscriptionStatus,
    device?: DeviceSubscription,
    listsAlsoOtherDevices: boolean,
    otherDevices?: DeviceSubscription[]
}

export function isSystemSubscriptionWrapper(obj: any): obj is SystemSubscriptionWrapper {
    return isObject(obj) &&
        hasOwnProperty(obj, "subscriptionStatus") &&
            inEnum(obj["subscriptionStatus"], SubscriptionStatus);
}

//appena completo questo ti pusho il vero dato
export type SubscribedDevice = any;

export interface PushServiceInterface {

    //questi ricalcano il funzionamento attuale di push helper
    /**
     * Recupera le informazioni relative alla subscription del dispositivo attualmente in uso,
     * 
     * @note rivisitazione di `getUserSubscription` di PushNotificationHelper
     */
    loadServiceWorkerAndGetSubscription(): Promise<SystemSubscriptionWrapper>


    /**
     * Recupera i device registrati e verifica se fra questi esiste 
     * il dispositivo locale (senza passare dall'attivazione del service worker o invocazione
     * del modulo firebase) - il check si basa unicamente sul device_id per identificare il dispositivo
     * corrente
     */
    getSubscriptionsAndCheckCurrentDevice(): Promise<SystemSubscriptionWrapper>

    /**
     * Sottoscrive il dispositivo in uso alle notifiche push
     * 
     * @note rivisitazione di `subscribe` di PushNotificationHelper
     */
    subscribeThisDevice(): Promise<SystemSubscriptionWrapper>
    /**
     * Cancella la sottoscrizione alle notifiche push per il dispositivo attualmente in uso
     * 
     * @note rivisitazione di `unsubscribe` di PushNotificationHelper
     */
    unsubscribeThisDevice(): Promise<boolean>
    
    // questi non implementare ancora
    enable(subIdentifier: SubscriptionIdentifier): Promise<SubscriptionListResponse>
    disable(subIdentifier: SubscriptionIdentifier): Promise<SubscriptionListResponse>
    listSubscribedDevices(): Promise<SubscriptionListResponse>

    isSystemEnabled(): boolean;
    isSubscriptionManualActivationContext(): boolean;
    
    onSubscriptionStatusChange(cb: ((x: SystemSubscriptionWrapper) => any)):void;
}